module.exports = __webpack_public_path__ + "static/media/14.d302ca6e.png";